import React, { useContext, useState } from 'react'
import { Button, Icon, Table } from 'semantic-ui-react'
import IntelMsg from '../ItelMsg'
import styles from './alert-mgmt.module.css'
import { AlertContext } from './alertContext'
import EditModal from './editModal'

const ALertDetails = () => {
  const { template, setViewDetails, setTemplate } = useContext(AlertContext)
  const [open, setOpen] = useState(false)
  console.log(template)
  const generateRows = () =>
    Object.keys(template.configurationTemplate).map((key, idx) => {
      if (key === 'id') return null
      if (key === 'template name')
        return (
          // eslint-disable-next-line react/no-array-index-key
          <Table.Row key={idx}>
            <Table.Cell
              className={styles.unique}
              style={{ textTransform: 'capitalize', textAlign: 'left' }}
              colSpan={2}
            >
              {key}: {template.configurationTemplate[key].toString()}
            </Table.Cell>
          </Table.Row>
        )

      return (
        // eslint-disable-next-line react/no-array-index-key
        <Table.Row key={idx}>
          <Table.Cell
            className={styles.common}
            style={{ textTransform: 'capitalize' }}
          >
            {key}
          </Table.Cell>
          <Table.Cell style={{ textAlign: 'center' }}>
            {template.configurationTemplate[key].toString()}
          </Table.Cell>
        </Table.Row>
      )
    })
  return (
    <>
      <div className={styles.container}>Configuration Template Details</div>
      <Table definition>
        <Table.Body>{generateRows()}</Table.Body>
      </Table>

      <div style={{ float: 'right' }}>
        <Button
          type="submit"
          style={{ backgroundColor: '#303d54', color: 'white' }}
          onClick={() => setOpen(true)}
        >
          Edit
        </Button>
      </div>

      <div>
        <Button
          type="submit"
          style={{ backgroundColor: '#303d54', color: 'white' }}
          onClick={() => {
            setViewDetails(false)
          }}
        >
          <Icon name="arrow left" />
          <IntelMsg id="back" />
        </Button>
      </div>

      <EditModal
        open={open}
        templateData={template.configurationTemplate}
        setOpen={setOpen}
        setTemplate={setTemplate}
      />
    </>
  )
}

export default ALertDetails
